import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";
import errorSign from "../../assets/images/errorSign.svg";
import "./mustyle.scss";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 340,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  paddingLeft: 4,
  paddingRight: 4,
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
};

const DeleteModal = ({ openDeleteModal, setOpenDeleteModal, handleDelete }) => {
  const handleClose = () => setOpenDeleteModal(false);

  const confirmDelete = () => {
    handleDelete();
    handleClose();
  };

  return (
    <div className="delte_modal_wrapper">
      <Modal
        open={openDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="delte_modal"
      >
        <Box sx={style}>
          <div className="Modal_header">
            <h1>
              <img src={errorSign} alt="" /> Delete
            </h1>
          </div>
          <div className="Modal_middle">
            <div className="inputdrapper">
              <p>Are you sure you want to delete this Customer?</p>
            </div>
          </div>
          <div className="Modal_footer">
            <Box sx={{ display: "flex" }}>
              <Button variant="outlined" className="cancelBtn" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="contained" className="saveBtn" onClick={confirmDelete}>
                Save
              </Button>
            </Box>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

DeleteModal.propTypes = {
  openDeleteModal: PropTypes.bool.isRequired,
  setOpenDeleteModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default DeleteModal;
